import React from "react";
import { AlertCircle } from "lucide-react";

export default function ErrorState({ title = "Something went wrong", message, details }) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
        <p className="text-red-600">{title}</p>
        {message ? <p className="text-gray-600 text-sm mt-2">{message}</p> : null}
        {details ? <p className="text-gray-500 text-xs mt-1">{details}</p> : null}
      </div>
    </div>
  );
}
